import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import './Cart.less';

const LOCALE_PREFIX = 'components/Cart/cart';

export class Item extends Component {

    static propTypes = {
        intl: intlShape.isRequired,
        item: PropTypes.shape(ItemShape).isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            expand: false
        };
    }

    toggleLines = (event) => {
        event.preventDefault();
        this.setState({ expand: !this.state.expand });
    };

    render() {
        const { item, intl } = this.props;
        const { expand } = this.state;

        return (
            <li className="cue-cart-item">
                <span className={`cue-cart-item-description pull-left${expand ? '' : ' cue-cart-item-overflown'}`}>
                    {item.name} {(item.quantity > 1) ? `(${item.quantity})` : null}
                    <br />

                    {expand && (
                        <a href="#"
                            data-automation-id="cartLess"
                            className="cue-cart-item-less pull-left"
                            onClick={this.toggleLines}
                        ><FormattedMessage id={`${LOCALE_PREFIX}.less`} />
                        </a>
                    )}
                </span>&nbsp;
                
                {!expand && (
                    <a href="#"
                        data-automation-id="cartMore"
                        className="cue-cart-item-more pull-left"
                        onClick={this.toggleLines}
                    ><FormattedMessage id={`${LOCALE_PREFIX}.more`} /></a>
                )}

                <div className="pull-right">
                    <span className="cue-cart-item-amount">{item.format_price}</span>
                </div>
            </li>
        );
    }
}

export const ItemShape = {
    format_price: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    quantity: PropTypes.number.isRequired
};

export default injectIntl(Item);
